// import { useEffect, useState } from "react";
// import { Table, Spinner, Button, Input, Form, FormGroup, Label } from "reactstrap";
// import axiosInstance from "../../Request";
// import { URL } from "../../api";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// const FIPReporting = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Filters
//   const [filterType, setFilterType] = useState("customerId");
//   const [filterValue, setFilterValue] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   // Fetch Data
//   const fetchFIPReport = async (filters = {}) => {
//     setLoading(true);
//     try {
//       const params = new URLSearchParams(filters).toString();
//       const url = `${URL.REPORTING_FIP}${params ? `?${params}` : ""}`;
//       const response = await axiosInstance.get(url);
//       setRows(response.data || []);
//     } catch (error) {
//       console.error("Error fetching FIP data:", error);
//       setRows([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // On component load
//   useEffect(() => {
//     fetchFIPReport();
//   }, []);

//   // Handle search
//   const handleSearch = (e) => {
//     e.preventDefault();
//     const filters = {};
//     if (filterValue) filters[filterType] = filterValue;
//     if (fromDate) filters.fromDate = fromDate;
//     if (toDate) filters.toDate = toDate;
//     fetchFIPReport(filters);
//   };

//   // Export to Excel
//   const exportToExcel = () => {
//     if (rows.length === 0) {
//       alert("No data available to export!");
//       return;
//     }
//     const ws = XLSX.utils.json_to_sheet(rows);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "FIP_Report");
//     const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     saveAs(new Blob([excelBuffer], { type: "application/octet-stream" }), "FIP_Report.xlsx");
//   };

//   // Small font & compact controls
//   const font12 = { fontSize: "10px" };
//   const inputSmStyle = { ...font12, height: "30px", padding: "2px 6px" };
//   const buttonSmStyle = { ...font12, padding: "4px 10px", height: "30px", lineHeight: "1" };

//   return (
//     <div style={font12}>
//       {/* Filters, Search, Export */}
//       <Form onSubmit={handleSearch} className="mb-3">
//         <div className="d-flex align-items-end flex-wrap" style={{ gap: "10px" }}>
//           {/* Filter Type */}
//           <FormGroup className="mb-0" style={{ minWidth: "130px" }}>
//             <Label className="mb-1 fw-bold" style={font12}>Filter Type</Label>
//             <Input
//               bsSize="sm"
//               type="select"
//               id="filterType"
//               value={filterType}
//               onChange={(e) => setFilterType(e.target.value)}
//               style={inputSmStyle}
//             >
//               <option value="customerId">Customer ID</option>
//               <option value="loanId">Loan ID</option>
//             </Input>
//           </FormGroup>

//           {/* Filter Value */}
//           <FormGroup className="mb-0" style={{ minWidth: "160px" }}>
//             <Label className="mb-1 fw-bold" style={font12}>
//               {filterType === "customerId" ? "Customer ID" : "Loan ID"}
//             </Label>
//             <Input
//               bsSize="sm"
//               id="filterValue"
//               type="text"
//               value={filterValue}
//               onChange={(e) => setFilterValue(e.target.value)}
//               placeholder={`Enter ${filterType === "customerId" ? "Customer ID" : "Loan ID"}`}
//               style={inputSmStyle}
//             />
//           </FormGroup>

//           {/* From Date */}
//           <FormGroup className="mb-0" style={{ minWidth: "150px" }}>
//             <Label className="mb-1 fw-bold" style={font12}>From Date</Label>
//             <Input
//               bsSize="sm"
//               id="fromDate"
//               type="date"
//               value={fromDate}
//               onChange={(e) => setFromDate(e.target.value)}
//               style={inputSmStyle}
//             />
//           </FormGroup>

//           {/* To Date */}
//           <FormGroup className="mb-0" style={{ minWidth: "150px" }}>
//             <Label className="mb-1 fw-bold" style={font12}>To Date</Label>
//             <Input
//               bsSize="sm"
//               id="toDate"
//               type="date"
//               value={toDate}
//               onChange={(e) => setToDate(e.target.value)}
//               style={inputSmStyle}
//             />
//           </FormGroup>

//           {/* Buttons */}
//           <div className="d-flex mb-0" style={{ gap: "6px" }}>
//             <Button color="primary" type="submit" style={buttonSmStyle}>Search</Button>
//             <Button color="success" onClick={exportToExcel} style={buttonSmStyle}>
//               Export To Excel
//             </Button>
//           </div>
//         </div>
//       </Form>

//       {/* Table */}
//       {loading ? (
//         <div className="d-flex align-items-center mt-3" style={{ gap: 8 }}>
//           <Spinner size="sm" /> <span>Loading FIP report...</span>
//         </div>
//       ) : rows.length === 0 ? (
//         <p className="mt-3 text-danger">No data found!</p>
//       ) : (
//         <div style={{ overflowX: "auto" }}>
//           <Table bordered striped hover responsive size="sm" className="mt-3 mb-0">
//             <thead className="thead-light">
//               <tr>
//                 <th style={font12}>#</th>
//                 <th style={font12}>ID</th>
//                 <th style={font12}>Loan ID</th>
//                 <th style={font12}>Customer ID</th>
//                 <th style={font12}>EMI Date</th>
//                 <th style={font12}>EMI Number</th>
//                 <th style={font12}>EMI Amount (₹)</th>
//                 <th style={font12}>Principal (₹)</th>
//                 <th style={font12}>Interest (₹)</th>
//                 <th style={font12}>Outstanding Amount (₹)</th>
//                 <th style={font12}>Outstanding Principal (₹)</th>
//                 <th style={font12}>Outstanding Interest (₹)</th>
//                 <th style={font12}>EMI Status</th>
//                 <th style={font12}>Status Value</th>
//                 <th style={font12}>DPD</th>
//                 <th style={font12}>Create Date</th>
//                 <th style={font12}>Update Date</th>
//                 <th style={font12}>Is Delete</th>
//               </tr>
//             </thead>
//             <tbody>
//               {rows.map((r, idx) => (
//                 <tr key={r.id}>
//                   <td style={font12}>{idx + 1}</td>
//                   <td style={font12}>{r.id}</td>
//                   <td style={font12}>{r.loan_id}</td>
//                   <td style={font12}>{r.customer_id}</td>
//                   <td style={font12}>{r.emi_date}</td>
//                   <td style={font12}>{r.emi_number}</td>
//                   <td style={font12}>{r.emi_amount?.toLocaleString()}</td>
//                   <td style={font12}>{r.principal?.toLocaleString()}</td>
//                   <td style={font12}>{r.interest?.toLocaleString()}</td>
//                   <td style={font12}>{r.outstanding_amount?.toLocaleString()}</td>
//                   <td style={font12}>{r.outstanding_principal?.toLocaleString()}</td>
//                   <td style={font12}>{r.outstanding_interest?.toLocaleString()}</td>
//                   <td style={font12}>{r.emi_status}</td>
//                   <td style={font12}>{r.emi_status_value}</td>
//                   <td style={font12}>{r.dpd}</td>
//                   <td style={font12}>{r.create_date}</td>
//                   <td style={font12}>{r.update_date}</td>
//                   <td style={font12}>{r.is_delete}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FIPReporting;



import { useEffect, useState } from "react";
import { Table, Spinner, Button, Input, Form, FormGroup, Label } from "reactstrap";
import axiosInstance from "../../Request";
import { URL } from "../../api";

const FIPReporting = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false); // State for Excel loading

  // Filters
  const [filterType, setFilterType] = useState("customerId");
  const [filterValue, setFilterValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 30; 
  const [hasNextPage, setHasNextPage] = useState(false);
  const [activeFilters, setActiveFilters] = useState({});

  const fetchFIPReport = async (page = 1, filters = {}) => {
    setLoading(true);
    try {
      const params = { ...filters };
      params.page = page - 1; 
      params.size = rowsPerPage;

      const response = await axiosInstance.get(URL.REPORTING_FIP, { params });
      
      const data = Array.isArray(response.data) ? response.data : [];
      setRows(data);
      setCurrentPage(page);
      setHasNextPage(data.length === rowsPerPage);
    } catch (error) {
      console.error("Error fetching FIP data:", error);
      setRows([]);
      setHasNextPage(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFIPReport(1, {});
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    const filters = {};
    if (filterValue.trim()) filters[filterType] = filterValue.trim();
    if (fromDate) filters.fromDate = fromDate;
    if (toDate) filters.toDate = toDate;
    
    setActiveFilters(filters);
    fetchFIPReport(1, filters);
  };

  // SECURE EXCEL API CALL (Authenticated & Scalable)
  const handleExcelExport = async () => {
    if (rows.length === 0) return alert("No data available to export!");

    setExporting(true); // Start spinner
    try {
      const params = { 
        ...activeFilters, 
        export: true 
      };

      // Calls backend with Bearer Token and treats response as a File (Blob)
      const response = await axiosInstance.get(URL.REPORTING_FIP, {
        params,
        responseType: 'blob', 
      });

      // Create a URL for the downloaded blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Filename with timestamp
      link.setAttribute('download', `FIP_Report_${new Date().getTime()}.csv`);
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export failed:", err);
      alert("Export failed. Please check your login session.");
    } finally {
      setExporting(false); // Stop spinner
    }
  };

  const font9 = { fontSize: "9px" }; 
  const inputSmStyle = { fontSize: "10px", height: "30px", padding: "2px 6px" };
  const buttonSmStyle = { fontSize: "10px", padding: "4px 10px", height: "30px", lineHeight: "1" };

  return (
    <div style={font9}>
      <Form onSubmit={handleSearch} className="mb-3">
        <div className="d-flex align-items-end flex-wrap" style={{ gap: "10px" }}>
          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">Filter Type</Label>
            <Input bsSize="sm" type="select" value={filterType} onChange={(e) => setFilterType(e.target.value)} style={inputSmStyle}>
              <option value="customerId">Customer ID</option>
              <option value="loanId">Loan ID</option>
            </Input>
          </FormGroup>
          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">{filterType === "customerId" ? "Customer ID" : "Loan ID"}</Label>
            <Input bsSize="sm" type="text" value={filterValue} onChange={(e) => setFilterValue(e.target.value)} style={inputSmStyle} />
          </FormGroup>
          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">From Date</Label>
            <Input bsSize="sm" type="date" value={fromDate} max={new Date().toISOString().split("T")[0]} onChange={(e) => setFromDate(e.target.value)} style={inputSmStyle} />
          </FormGroup>
          <FormGroup className="mb-0">
            <Label className="mb-1 fw-bold">To Date</Label>
            <Input bsSize="sm" type="date" value={toDate} max={new Date().toISOString().split("T")[0]} onChange={(e) => setToDate(e.target.value)} style={inputSmStyle} />
          </FormGroup>
          <div className="d-flex" style={{ gap: "6px" }}>
            <Button color="primary" type="submit" style={buttonSmStyle}>Search</Button>
            <Button 
                color="success" 
                onClick={handleExcelExport} 
                style={buttonSmStyle}
                disabled={exporting}
            >
              {exporting ? (
                <>
                  <Spinner size="sm" color="light" className="me-1" />
                  Wait...
                </>
              ) : (
                "Excel"
              )}
            </Button>
          </div>
        </div>
      </Form>

      {loading ? (
        <div className="text-center p-4"><Spinner size="sm" /> Loading FIP Summary...</div>
      ) : (
        <>
          <div style={{ overflowX: "auto" }}>
            <Table bordered striped hover responsive size="sm" className="mt-3 text-nowrap">
              <thead className="thead-light">
                <tr>
                  <th>#</th>
                  <th>ID</th>
                  <th>Loan ID</th>
                  <th>Cust ID</th>
                  <th>fintech Name</th>
                  <th>EMI Date</th>
                  <th>EMI #</th>
                  <th>EMI Amt</th>
                  <th>Prin Due</th>
                  <th>Int Due</th>
                  <th>Out Prin</th>
                  <th>Out Int</th>
                  <th>Out Amt</th>
                  <th>Pending Amt</th>
                  <th>DPD</th>
                  <th>Status</th>
                  <th>Update Date</th>
                  <th>Create Date</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map((r, idx) => (
                    <tr key={idx}>
                      <td>{(currentPage - 1) * rowsPerPage + idx + 1}</td>
                      <td>{r.id}</td>
                      <td>{r.loan_id}</td>
                      <td>{r.customer_id}</td>
                      <td>{r.fintech_name}</td>
                      <td>{r.emi_date}</td>
                      <td>{r.emi_number}</td>
                      <td>₹{Number(r.emi_amount || 0).toLocaleString()}</td>
                      <td>{r.principal_due ? `₹${Number(r.principal_due).toLocaleString()}` : "-"}</td>
                      <td>{r.interest_due ? `₹${Number(r.interest_due).toLocaleString()}` : "-"}</td>
                      <td>₹{Number(r.outstanding_principal || 0).toLocaleString()}</td>
                      <td>₹{Number(r.outstanding_interest || 0).toLocaleString()}</td>
                      <td>₹{Number(r.outstanding_amount || 0).toLocaleString()}</td>
                      <td>{r.pending_emi_amount ? `₹${Number(r.pending_emi_amount).toLocaleString()}` : "-"}</td>
                      <td>{r.dpd ?? "0"}</td>
                      <td className="fw-bold">{r.emi_status_value}</td>
                      <td>{r.update_date}</td>
                      <td>{r.create_date}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="17" className="text-center text-muted">No data found.</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="d-flex justify-content-center mt-3">
            <div className="d-flex align-items-center" style={{ gap: "5px" }}>
              <Button color="outline-primary" size="sm" style={buttonSmStyle}
                onClick={() => fetchFIPReport(currentPage - 1, activeFilters)}
                disabled={currentPage === 1}>Prev</Button>

              {Array.from({ length: hasNextPage ? currentPage + 1 : currentPage }, (_, i) => {
                const pageNum = i + 1;
                if (pageNum >= currentPage - 1 && pageNum <= currentPage + 1) {
                  return (
                    <Button key={pageNum} size="sm" style={buttonSmStyle}
                      color={currentPage === pageNum ? "primary" : "outline-primary"}
                      onClick={() => fetchFIPReport(pageNum, activeFilters)}>{pageNum}</Button>
                  );
                }
                return null;
              })}

              <Button color="outline-primary" size="sm" style={buttonSmStyle}
                onClick={() => fetchFIPReport(currentPage + 1, activeFilters)}
                disabled={!hasNextPage}>Next</Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FIPReporting;